// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"0d706eaa","196":"96e2482a","304":"7d848c1a","408":"bfea6ddc","617":"7d4d87a9","843":"f9519995","882":"a6d9fa04"}[chunkId] + ".chunk.js";
};